/* Top menu on desktop: keeps every item on one line. The gap between items is 28px from 1440px (sg-mega-menu.css);
   when the items don't fit on one row (a new menu item, a long label, a narrower screen) the gap steps down
   28 → 24 → 20 → 16 → 14 → 12px until they do, so a new item never wraps the bar (Van 2026-10-20). */
(() => {
  const menu = document.querySelector('.section-header-advanced .header__inline-menu .list-menu--inline');
  if (!menu) return;
  const steps = [28, 24, 20, 16, 14, 12];

  const fits = () => {
    const items = [...menu.children].filter((li) => li.offsetWidth);
    const tops = new Set(items.map((li) => Math.round(li.getBoundingClientRect().top)));
    return tops.size <= 1 && menu.scrollWidth <= menu.clientWidth + 1;
  };

  const fit = () => {
    menu.style.columnGap = '';
    if (window.innerWidth < 1200 || fits()) return;
    const base = parseFloat(getComputedStyle(menu).columnGap) || 16;
    for (const gap of steps.filter((step) => step < base)) {
      menu.style.columnGap = `${gap}px`;
      if (fits()) return;
    }
  };

  window.sgHeaderFit = fit;
  fit();
  window.addEventListener('load', fit);
  let frame = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fit);
  });
})();
